import PropTypes from 'prop-types';
import { createElement } from 'react';

const propTypes = {
    children: PropTypes.node.isRequired,
};

const Trigger = ({ as, children, ...otherProps }) => {
    return (
        createElement('span', { ...otherProps }, children)
    );
}

Trigger.defaultProps = {
    as: 'span',
};

Trigger.displayName = 'Trigger';
Trigger.propTypes = propTypes;

export default Trigger;
